"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TotemChatApi = exports.TotemChatApiFactory = exports.TotemChatApiFp = exports.TotemChatApiAxiosParamCreator = exports.FeedbackApi = exports.FeedbackApiFactory = exports.FeedbackApiFp = exports.FeedbackApiAxiosParamCreator = exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.FeedbackType = exports.CompletionErrorCode = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.CompletionErrorCode = {
    CompletionFailed: 'completion_failed',
    PromptFiltered: 'prompt_filtered',
    RateLimitExceeded: 'rate_limit_exceeded',
    ServiceUnavailable: 'service_unavailable',
    UserSentMostRecentMessage: 'user_sent_most_recent_message'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.FeedbackType = {
    Positive: 'positive',
    Negative: 'negative'
};
/**
 * DefaultApi - axios parameter creator
 * @export
 */
const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Read Root
         * @param {Chattoken} [chatToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readRootGet: (chatToken_1, ...args_1) => __awaiter(this, [chatToken_1, ...args_1], void 0, function* (chatToken, options = {}) {
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Read Root
         * @param {Chattoken} [chatToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readRootGet(chatToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.readRootGet(chatToken, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.readRootGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        /**
         *
         * @summary Read Root
         * @param {Chattoken} [chatToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readRootGet(chatToken, options) {
            return localVarFp.readRootGet(chatToken, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends base_1.BaseAPI {
    /**
     *
     * @summary Read Root
     * @param {Chattoken} [chatToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    readRootGet(chatToken, options) {
        return (0, exports.DefaultApiFp)(this.configuration).readRootGet(chatToken, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DefaultApi = DefaultApi;
/**
 * FeedbackApi - axios parameter creator
 * @export
 */
const FeedbackApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Post Feedback
         * @param {number} userId
         * @param {number} chatId
         * @param {number} messageId
         * @param {FeedbackRequestBody} feedbackRequestBody
         * @param {Chattoken} [chatToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendFeedbackAboutMessage: (userId_1, chatId_1, messageId_1, feedbackRequestBody_1, chatToken_1, ...args_1) => __awaiter(this, [userId_1, chatId_1, messageId_1, feedbackRequestBody_1, chatToken_1, ...args_1], void 0, function* (userId, chatId, messageId, feedbackRequestBody, chatToken, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('sendFeedbackAboutMessage', 'userId', userId);
            // verify required parameter 'chatId' is not null or undefined
            (0, common_1.assertParamExists)('sendFeedbackAboutMessage', 'chatId', chatId);
            // verify required parameter 'messageId' is not null or undefined
            (0, common_1.assertParamExists)('sendFeedbackAboutMessage', 'messageId', messageId);
            // verify required parameter 'feedbackRequestBody' is not null or undefined
            (0, common_1.assertParamExists)('sendFeedbackAboutMessage', 'feedbackRequestBody', feedbackRequestBody);
            const localVarPath = `/feedback/{user_id}/{chat_id}/{message_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"chat_id"}}`, encodeURIComponent(String(chatId)))
                .replace(`{${"message_id"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(feedbackRequestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.FeedbackApiAxiosParamCreator = FeedbackApiAxiosParamCreator;
/**
 * FeedbackApi - functional programming interface
 * @export
 */
const FeedbackApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.FeedbackApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Post Feedback
         * @param {number} userId
         * @param {number} chatId
         * @param {number} messageId
         * @param {FeedbackRequestBody} feedbackRequestBody
         * @param {Chattoken} [chatToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendFeedbackAboutMessage(userId, chatId, messageId, feedbackRequestBody, chatToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendFeedbackAboutMessage(userId, chatId, messageId, feedbackRequestBody, chatToken, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FeedbackApi.sendFeedbackAboutMessage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.FeedbackApiFp = FeedbackApiFp;
/**
 * FeedbackApi - factory interface
 * @export
 */
const FeedbackApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.FeedbackApiFp)(configuration);
    return {
        /**
         *
         * @summary Post Feedback
         * @param {number} userId
         * @param {number} chatId
         * @param {number} messageId
         * @param {FeedbackRequestBody} feedbackRequestBody
         * @param {Chattoken} [chatToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendFeedbackAboutMessage(userId, chatId, messageId, feedbackRequestBody, chatToken, options) {
            return localVarFp.sendFeedbackAboutMessage(userId, chatId, messageId, feedbackRequestBody, chatToken, options).then((request) => request(axios, basePath));
        },
    };
};
exports.FeedbackApiFactory = FeedbackApiFactory;
/**
 * FeedbackApi - object-oriented interface
 * @export
 * @class FeedbackApi
 * @extends {BaseAPI}
 */
class FeedbackApi extends base_1.BaseAPI {
    /**
     *
     * @summary Post Feedback
     * @param {number} userId
     * @param {number} chatId
     * @param {number} messageId
     * @param {FeedbackRequestBody} feedbackRequestBody
     * @param {Chattoken} [chatToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedbackApi
     */
    sendFeedbackAboutMessage(userId, chatId, messageId, feedbackRequestBody, chatToken, options) {
        return (0, exports.FeedbackApiFp)(this.configuration).sendFeedbackAboutMessage(userId, chatId, messageId, feedbackRequestBody, chatToken, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.FeedbackApi = FeedbackApi;
/**
 * TotemChatApi - axios parameter creator
 * @export
 */
const TotemChatApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get Chats For User
         * @param {number} userId
         * @param {boolean} [latest]
         * @param {Chattoken} [chatToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersChats: (userId_1, latest_1, chatToken_1, ...args_1) => __awaiter(this, [userId_1, latest_1, chatToken_1, ...args_1], void 0, function* (userId, latest, chatToken, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('getAllUsersChats', 'userId', userId);
            const localVarPath = `/chat/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (latest !== undefined) {
                localVarQueryParameter['latest'] = latest;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get Chat
         * @param {number} userId
         * @param {number} chatId
         * @param {Chattoken} [chatToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatById: (userId_2, chatId_1, chatToken_2, ...args_2) => __awaiter(this, [userId_2, chatId_1, chatToken_2, ...args_2], void 0, function* (userId, chatId, chatToken, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('getChatById', 'userId', userId);
            // verify required parameter 'chatId' is not null or undefined
            (0, common_1.assertParamExists)('getChatById', 'chatId', chatId);
            const localVarPath = `/chat/{user_id}/{chat_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"chat_id"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Post User Message
         * @param {number} chatId
         * @param {number} userId
         * @param {MessageRequestBodyS} messageRequestBodyS
         * @param {Chattoken} [chatToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessageToChat: (chatId_2, userId_3, messageRequestBodyS_1, chatToken_3, ...args_3) => __awaiter(this, [chatId_2, userId_3, messageRequestBodyS_1, chatToken_3, ...args_3], void 0, function* (chatId, userId, messageRequestBodyS, chatToken, options = {}) {
            // verify required parameter 'chatId' is not null or undefined
            (0, common_1.assertParamExists)('sendMessageToChat', 'chatId', chatId);
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('sendMessageToChat', 'userId', userId);
            // verify required parameter 'messageRequestBodyS' is not null or undefined
            (0, common_1.assertParamExists)('sendMessageToChat', 'messageRequestBodyS', messageRequestBodyS);
            const localVarPath = `/chat/{user_id}/{chat_id}`
                .replace(`{${"chat_id"}}`, encodeURIComponent(String(chatId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(messageRequestBodyS, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Post New Chat
         * @param {number} userId
         * @param {Chattoken} [chatToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startNewChat: (userId_4, chatToken_4, ...args_4) => __awaiter(this, [userId_4, chatToken_4, ...args_4], void 0, function* (userId, chatToken, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('startNewChat', 'userId', userId);
            const localVarPath = `/chat/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.TotemChatApiAxiosParamCreator = TotemChatApiAxiosParamCreator;
/**
 * TotemChatApi - functional programming interface
 * @export
 */
const TotemChatApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.TotemChatApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get Chats For User
         * @param {number} userId
         * @param {boolean} [latest]
         * @param {Chattoken} [chatToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersChats(userId, latest, chatToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllUsersChats(userId, latest, chatToken, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TotemChatApi.getAllUsersChats']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get Chat
         * @param {number} userId
         * @param {number} chatId
         * @param {Chattoken} [chatToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatById(userId, chatId, chatToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getChatById(userId, chatId, chatToken, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TotemChatApi.getChatById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Post User Message
         * @param {number} chatId
         * @param {number} userId
         * @param {MessageRequestBodyS} messageRequestBodyS
         * @param {Chattoken} [chatToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessageToChat(chatId, userId, messageRequestBodyS, chatToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendMessageToChat(chatId, userId, messageRequestBodyS, chatToken, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TotemChatApi.sendMessageToChat']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Post New Chat
         * @param {number} userId
         * @param {Chattoken} [chatToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startNewChat(userId, chatToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.startNewChat(userId, chatToken, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TotemChatApi.startNewChat']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.TotemChatApiFp = TotemChatApiFp;
/**
 * TotemChatApi - factory interface
 * @export
 */
const TotemChatApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.TotemChatApiFp)(configuration);
    return {
        /**
         *
         * @summary Get Chats For User
         * @param {number} userId
         * @param {boolean} [latest]
         * @param {Chattoken} [chatToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersChats(userId, latest, chatToken, options) {
            return localVarFp.getAllUsersChats(userId, latest, chatToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Chat
         * @param {number} userId
         * @param {number} chatId
         * @param {Chattoken} [chatToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatById(userId, chatId, chatToken, options) {
            return localVarFp.getChatById(userId, chatId, chatToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post User Message
         * @param {number} chatId
         * @param {number} userId
         * @param {MessageRequestBodyS} messageRequestBodyS
         * @param {Chattoken} [chatToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessageToChat(chatId, userId, messageRequestBodyS, chatToken, options) {
            return localVarFp.sendMessageToChat(chatId, userId, messageRequestBodyS, chatToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post New Chat
         * @param {number} userId
         * @param {Chattoken} [chatToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startNewChat(userId, chatToken, options) {
            return localVarFp.startNewChat(userId, chatToken, options).then((request) => request(axios, basePath));
        },
    };
};
exports.TotemChatApiFactory = TotemChatApiFactory;
/**
 * TotemChatApi - object-oriented interface
 * @export
 * @class TotemChatApi
 * @extends {BaseAPI}
 */
class TotemChatApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get Chats For User
     * @param {number} userId
     * @param {boolean} [latest]
     * @param {Chattoken} [chatToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TotemChatApi
     */
    getAllUsersChats(userId, latest, chatToken, options) {
        return (0, exports.TotemChatApiFp)(this.configuration).getAllUsersChats(userId, latest, chatToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Chat
     * @param {number} userId
     * @param {number} chatId
     * @param {Chattoken} [chatToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TotemChatApi
     */
    getChatById(userId, chatId, chatToken, options) {
        return (0, exports.TotemChatApiFp)(this.configuration).getChatById(userId, chatId, chatToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post User Message
     * @param {number} chatId
     * @param {number} userId
     * @param {MessageRequestBodyS} messageRequestBodyS
     * @param {Chattoken} [chatToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TotemChatApi
     */
    sendMessageToChat(chatId, userId, messageRequestBodyS, chatToken, options) {
        return (0, exports.TotemChatApiFp)(this.configuration).sendMessageToChat(chatId, userId, messageRequestBodyS, chatToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post New Chat
     * @param {number} userId
     * @param {Chattoken} [chatToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TotemChatApi
     */
    startNewChat(userId, chatToken, options) {
        return (0, exports.TotemChatApiFp)(this.configuration).startNewChat(userId, chatToken, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TotemChatApi = TotemChatApi;
